import React, { useEffect, useState } from 'react';
import { Button, Grid, Paper, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import getMiddlewareSocketInstance from '../../../../../../../common/SocketMiddleware';
import { inelioClearAlarmAction } from '../../../../../../../data/Products/actions';

const INELIO_ALARMS = 'getInelioActiveAlarms';
const regex = new RegExp(',');

const isCorrectProduct = (props, args) => {
    return props.fheCenter_mac === args.fheCenter_mac && props.product_identifier === args.product_identifier;
};

function InelioAlarms({ classes, ...props }) {
    const [alarms, setAlarms] = useState({});
    const alarmsEntries = Object.entries(alarms);

    useEffect(() => {
        getMiddlewareSocketInstance().on(INELIO_ALARMS, handleAlarms);
        return () => {
            getMiddlewareSocketInstance() && getMiddlewareSocketInstance().removeListener(INELIO_ALARMS, handleAlarms);
        };
    }, []);

    const handleAlarms = args => {
        if (isCorrectProduct(props, args)) {
            setAlarms(alarm => ({ ...alarm, [args.slave]: args.alarmCodes }));
        }
    };

    const handleClick = (slave, alarmCode) => {
        const { fheCenter_mac, product_identifier } = props;
        inelioClearAlarmAction({ fheCenter_mac, product_identifier, slave, alarmCode });
    };

    const renderButtons = (slave, values) => {
        if (regex.test(values)) {
            return values.split(',').map(value => (
                <Button
                    style={{ marginRight: 8 }}
                    size="small"
                    color="primary"
                    variant="contained"
                    key={value}
                    onClick={() => handleClick(slave, value)}
                >
                    {value}
                </Button>
            ));
        } else {
            return (
                <Button size="small" color="primary" variant="contained" onClick={() => handleClick(slave, values)}>
                    {values}
                </Button>
            );
        }
    };

    return (
        <Grid container>
            <Grid item xs={12} className={classes.header}>
                Alarmes
            </Grid>
            <Paper style={{ width: '100%' }}>
                <Grid container item xs={12} className={classes.content}>
                    {alarmsEntries.length
                        ? alarmsEntries.map(([key, value]) => {
                              return (
                                  <Grid container className={classes.alarms} item key={key} xs={12}>
                                      <div className={classes.slave}>{`${key} : `}</div>
                                      <div className={classes.buttons}>{renderButtons(key, value)}</div>
                                  </Grid>
                              );
                          })
                        : 'Aucune Alarme'}
                </Grid>
            </Paper>
        </Grid>
    );
}

InelioAlarms.propTypes = {
    classes: PropTypes.object.isRequired,
    fheCenter_mac: PropTypes.string.isRequired,
    product_identifier: PropTypes.string.isRequired,
};
InelioAlarms.defaultProps = {};

const styles = theme => ({
    header: {
        background: theme.palette.primary.main,
        fontSize: 16,
        color: theme.palette.common.white,
        padding: 8,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
    },
    content: {
        padding: 10,
    },
    alarms: { marginBottom: 6 },
    slave: { display: 'flex', alignItems: 'center', marginRight: 6 },
    buttons: {},
});

export default withRouter(
    connect(
        null,
        dispatch => bindActionCreators({ inelioClearAlarmAction }, dispatch),
    )(withStyles(styles, { withTheme: true })(InelioAlarms)),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19INL/components/InelioAlarms.js